import { accordionConfig as o } from "./components/accordion-theme.js";
import { badgeConfig as r } from "./components/badge-theme.js";
import { buttonConfig as i } from "./components/button-theme.js";
import { checkboxConfig as m } from "./components/checkbox-theme.js";
import { comboboxConfig as f } from "./components/combobox-theme.js";
import { dateCellConfig as t } from "./components/date-cell-theme.js";
import { dateCellWeekConfig as n } from "./components/datepicker-week-theme.js";
import { dividerConfig as e } from "./components/divider-theme.js";
import { drawerConfig as g } from "./components/drawer-theme.js";
import { formErrorConfig as C } from "./components/form-error-theme.js";
import { formLabelConfig as p } from "./components/form-label-theme.js";
import { formConfig as a } from "./components/form-theme.js";
import { inputConfig as l } from "./components/input-theme.js";
import { linkConfig as b } from "./components/link-theme.js";
import { menuConfig as c } from "./components/menu-theme.js";
import { modalConfig as d } from "./components/modal-theme.js";
import { paginatorConfig as x } from "./components/paginator-theme.js";
import { radioConfig as k } from "./components/radio-theme.js";
import { selectConfig as s } from "./components/select-theme.js";
import { switchConfig as u } from "./components/switch-theme.js";
import { tableConfig as T } from "./components/table-theme.js";
import { tabsConfig as h } from "./components/tabs-theme.js";
import { tagConfig as w } from "./components/tag-theme.js";
import { textConfig as D } from "./components/text-theme.js";
import { textareaConfig as F } from "./components/textarea-theme.js";
const Y = {
  Accordion: o,
  Button: i,
  Badge: r,
  Divider: e,
  Radio: k,
  Input: l,
  Modal: d,
  Checkbox: m,
  Tabs: h,
  Select: s,
  Form: a,
  FormLabel: p,
  FormError: C,
  Link: b,
  DateCell: t,
  DateCellWeek: n,
  Switch: u,
  Text: D,
  Textarea: F,
  Menu: c,
  Table: T,
  Paginator: x,
  Tag: w,
  Combobox: f,
  Drawer: g
};
export {
  Y as componentsConfig
};
